import './index.css';

import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useAutoLogout, useIsActive } from '../../../hooks';
import useMedia from '../../../hooks/useMedia';
import { useAppDispatch, useAppSelector } from '../../../reducer/hooks';
import { selectIsMobileView } from '../../../reducer/mediaSlice';
import { selectStuff, setIsRefreshingToken } from '../../../reducer/stuffSlice';
import { enumMapping, getIsRedirectLoginPath } from '../../../utils';
import { enumTimezone } from '../../../utils/constant';
import { Content, ContentWithSidebar, ContentWithTopBar } from './sx';

import { useZusMenuCollapsedStore } from '../../../zustand/store';

import Menu from '../Menu';
import SideMenu from '../SideMenu';
import TopBar from '../TopBar';
import useAssets from '../../../hooks/useAssets';
import useChains from '../../../hooks/useChains';
import useMerchantList from '../../../hooks/useMerchantList';
import useAssetInfosList from '../../../hooks/useAssetInfosList';

const Enum = {
  timezones: enumMapping(enumTimezone),
};

export default function LayoutBar(props: any) {
  const [isSideMenuCollapse, setIsSideMenuCollapse] = useState(false);
  const [isShowSideMenuInMobileView, setIsShowSideMenuInMobileView] = useState(false);
  const zusMenuCollapsed = useZusMenuCollapsedStore();

  const dispatch = useAppDispatch();

  const { isRefreshingToken } = useAppSelector(selectStuff);

  useMedia();
  useAutoLogout();
  useIsActive();

  // useAssets({ shouldFetch: true });
  useChains({ shouldFetch: true });
  useMerchantList({ shouldFetch: true });
  useAssetInfosList({ shouldFetch: true });

  const isMobileView = useAppSelector(selectIsMobileView);

  // prevent isRefreshingToken dead lock
  useEffect(() => {
    const TIMEOUT_SECOND = 10 * 1000;

    let timeoutId: ReturnType<typeof setTimeout>;

    if (isRefreshingToken) {
      timeoutId = setTimeout(() => {
        dispatch(setIsRefreshingToken(false));
      }, TIMEOUT_SECOND);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isRefreshingToken]);

  const onCollapseClick = () => {
    setIsSideMenuCollapse(!isSideMenuCollapse);
  };

  useEffect(() => {
    if (isMobileView) {
      setIsShowSideMenuInMobileView(false);
      setIsSideMenuCollapse(false);
    } else {
      setIsShowSideMenuInMobileView(true);
    }
  }, [isMobileView]);

  useEffect(() => {
    zusMenuCollapsed.setIsMenuCollapsed(isSideMenuCollapse);
  }, [isSideMenuCollapse]);

  if (getIsRedirectLoginPath()) return <>{props.children}</>;

  return (
    <div
      className={isShowSideMenuInMobileView && isMobileView ? 'content-with-sidebar-container' : ''}
    >
      <ContentWithSidebar>
        {/* Side Menu */}
        <SideMenu
          isDeskTopMenuCollapse={isSideMenuCollapse}
          onCollapseClick={onCollapseClick}
          isShowSideMenuInMobileView={isShowSideMenuInMobileView}
        >
          <Menu
            closeMobileSideMenu={() => {
              if (!isMobileView) return;
              setIsShowSideMenuInMobileView(false);
            }}
          />
        </SideMenu>

        {/* Black overlay for mobile side menu */}
        {isMobileView && isShowSideMenuInMobileView && !isSideMenuCollapse && (
          <div className="side-menu-overlay" onClick={() => setIsShowSideMenuInMobileView(false)} />
        )}

        <ContentWithTopBar isMobileView={isMobileView}>
          {/* Top Bar */}
          <TopBar
            isShowSideMenuInMobileView={isShowSideMenuInMobileView}
            setIsShowSideMenuInMobileView={setIsShowSideMenuInMobileView}
            setIsSideMenuCollapse={setIsSideMenuCollapse}
          />

          <Content>
            <Outlet />
          </Content>
        </ContentWithTopBar>
      </ContentWithSidebar>
    </div>
  );
}
